export const SAVE_ALL_UNITS = 'SAVE_ALL_UNITS'
export const SAVE_UNIT = 'SAVE_UNIT'
